import { render, staticRenderFns } from "./SaleDetailsTabInformation.vue?vue&type=template&id=7800cd12&scoped=true&"
import script from "./SaleDetailsTabInformation.vue?vue&type=script&lang=js&"
export * from "./SaleDetailsTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./SaleDetailsTabInformation.vue?vue&type=style&index=0&id=7800cd12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7800cd12",
  null
  
)

export default component.exports